import {Stack as MUIStack} from '@mui/material'

export const Stack = MUIStack
